import React from 'react';

import {
    AspectRatio,
    Orientation,
    ProgressCircular,
    SkeletonRectangle,
    SkeletonRectangleVariant,
} from '@lumapps/lumx/react';

import { usePlayerClassnames } from '../../hooks';

import './Skeleton.scss';

interface SkeletonProps {
    /** Custom class name */
    className?: string;
    /** Video orientation, used to set the correct aspect ratio on the skeleton */
    orientation?: Orientation;
}
export function Skeleton({ className, orientation }: SkeletonProps) {
    const { element } = usePlayerClassnames();
    const aspectRatio = orientation === Orientation.vertical ? AspectRatio.vertical : AspectRatio.square;

    return (
        <div className={element('skeleton', [className])}>
            <SkeletonRectangle
                aspectRatio={aspectRatio}
                className={element('skeleton__rectangle')}
                variant={SkeletonRectangleVariant.rounded}
            />

            <ProgressCircular className={element('skeleton__progress')} />
        </div>
    );
}
